import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import TemplateBuilder from '../../components/EmailPlatform/TemplateBuilder';

const GET_TEMPLATE_QUERY = gql`
  query GetEmailTemplate($id: ID!) {
    emailTemplate(id: $id) {
      id
      name
      subject
      bodyHtml
      title
      subTitle
      headerText
      buttonText
      buttonUrl
      category
      layoutName
      locked
      companyId
      createdById
      version
      deletedAt
      createdAt
      updatedAt
      template_tag_list
    }
    availableMergeFields
    availableEmailLayouts
  }
`;

const GET_MERGE_FIELDS_AND_LAYOUTS = gql`
  query GetMergeFieldsAndLayouts {
    availableMergeFields
    availableEmailLayouts
  }
`;

const TemplateBuilderContainer = (props) => {
  // Get template ID from React Router match params
  const templateId = props.match?.params?.id;
  const isEditing = !!templateId;

  if (isEditing) {
    return (
      <Query query={GET_TEMPLATE_QUERY} variables={{ id: templateId }}>
        {({ loading, error, data }) => {
          if (loading) return <div style={{ padding: '20px' }}>Loading template...</div>;
          if (error) return <div style={{ padding: '20px' }}>Error loading template: {error.message}</div>;

          return (
            <TemplateBuilder
              {...props}
              template={data?.emailTemplate}
              mergeFields={data?.availableMergeFields || []}
              emailLayouts={data?.availableEmailLayouts || []}
            />
          );
        }}
      </Query>
    );
  }

  return (
    <Query query={GET_MERGE_FIELDS_AND_LAYOUTS}>
      {({ loading, error, data }) => {
        if (loading) return <div style={{ padding: '20px' }}>Loading...</div>;
        if (error) return <div style={{ padding: '20px' }}>Error: {error.message}</div>;

        return (
          <TemplateBuilder
            {...props}
            mergeFields={data?.availableMergeFields || []}
            emailLayouts={data?.availableEmailLayouts || []}
          />
        );
      }}
    </Query>
  );
};

TemplateBuilderContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

export default TemplateBuilderContainer;
